import ErrorBoundary from "shared/components/ErrorBoundary";
import ImageGallery from "react-image-gallery";
import Lightbox, { Modal, ModalGateway } from "react-images";
import React from "react";
import { PropTypes } from "prop-types";
import { withTheme } from "@material-ui/core/styles";
import "react-image-gallery/styles/css/image-gallery.css";
import styles from "./styles.css";
import config from "shared/config";
import "../../App/styles.css";

// require("react-image-gallery/styles/scss/image-gallery.scss");

class ProductSlider extends React.Component {
	constructor() {
		super();
		this.state = {
			initialIndex: 0,
			lightboxIndex: 0,
			lightboxOpen: false,
			prevIndex: 0, // Index of thumbnail that was last active
		};
		this.closeLightbox = this.closeLightbox.bind(this);
		this.goToThumbnail = this.goToThumbnail.bind(this);
		this.handleSlide = this.handleSlide.bind(this); // Lets us call other functions within handleSlide()
		this.nextLightboxImage = this.nextLightboxImage.bind(this);
		this.openLightbox = this.openLightbox.bind(this);
		this.previousLightboxImage = this.previousLightboxImage.bind(this);
		this.setThumbnailBorder = this.setThumbnailBorder.bind(this);
	}

	componentDidMount() {
		this.setThumbnailBorder(0);
	}

	setThumbnailBorder(index) {
		const { theme } = this.props;
		const thumbnails = document.getElementsByClassName(
			"image-gallery-thumbnail"
		);
		if (thumbnails.length > 0) {
			thumbnails[index].style.borderColor = theme.palette.secondary.main;
			if (index !== this.state.prevIndex)
				thumbnails[this.state.prevIndex].style.borderColor = "";
		}
	}

	/**
	 * convert array of product images
	 * into array format needed for the slider
	 * @param {array} productImages
	 */
	getImages = (productImages) =>
		productImages
			? productImages.map((image) => ({
					original: image.full,
					thumbnail: image.thumbnail,
			  }))
			: [];

	/**
	 * convert array of product images
	 * into array format for the lightbox
	 */
	getLightboxImages = (productImages) =>
		productImages
			? productImages.map((image) => ({
					src: image.full,
					thumbnail: image.thumbnail,
			  }))
			: [];

	closeLightbox() {
		const { initialIndex } = this.state;
		this.setState({
			lightboxIndex: initialIndex,
			lightboxOpen: false,
		});
	}

	goToThumbnail(index) {
		// index is given from react-images
		this.setState({
			lightboxIndex: index,
		});
	}

	handleSlide(index) {
		this.setThumbnailBorder(index);
		this.setState({
			lightboxIndex: index,
			prevIndex: index,
		});
	}

	nextLightboxImage() {
		const { lightboxIndex } = this.state;
		this.setState({
			lightboxIndex: lightboxIndex + 1,
		});
	}

	openLightbox() {
		const { lightboxIndex } = this.state;
		this.setState({ initialIndex: lightboxIndex, lightboxOpen: true });
	}

	previousLightboxImage() {
		const { lightboxIndex } = this.state;
		this.setState({
			lightboxIndex: lightboxIndex - 1,
		});
	}

	// this will auto scale images to the size of the container
	renderImage = (item) => (
		<div>
			<img
				src={item.original}
				alt="productImg"
				className={styles["slider-image"]}
			/>
		</div>
	);

	render() {
		const { lightboxIndex, lightboxOpen } = this.state;
		const lightboxImages = this.getLightboxImages(this.props.pictureUrls);
		const showNav = config.PRODUCT.SliderShowNav;

		return (
			<>
			<ErrorBoundary>
				<div className={showNav? "storis-image-gallery-override": ""}>
					<ImageGallery
						items={this.getImages(this.props.pictureUrls)}
						onClick={this.openLightbox}
						onSlide={this.handleSlide}
						preventDefaultTouchmoveEvent={false}
						renderItem={this.renderImage}
						showBullets={false}
						showFullscreenButton={false}
						showNav={showNav} // pull from new setting
						showPlayButton={false}
						slideDuration={300}
					/>
					<ModalGateway>
						{lightboxOpen ? (
							<Modal onClose={this.closeLightbox}>
								<Lightbox
									backdropClosesModal
									currentImage={lightboxIndex}
									images={lightboxImages}
									views={lightboxImages}
									isOpen={lightboxOpen}
									onClickNext={this.nextLightboxImage}
									onClickPrev={this.previousLightboxImage}
									onClickThumbnail={this.goToThumbnail}
									onClose={this.closeLightbox}
									preventScroll={false}
									showImageCount={false}
									showThumbnails
								/>
							</Modal>
						) : null}
					</ModalGateway>
				</div>
			</ErrorBoundary>
			</>
		);
	}
}

ProductSlider.propTypes = {
	pictureUrls: PropTypes.arrayOf(
		PropTypes.shape({
			full: PropTypes.string,
			thumbnail: PropTypes.string,
		})
	),
	theme: PropTypes.instanceOf(Object).isRequired,
};

ProductSlider.defaultProps = {
	pictureUrls: [],
};

export default withTheme(ProductSlider);
